"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouterActions = exports.useRouter = void 0;
const react_1 = __importDefault(require("react"));
const guard_1 = require("../guard");
const RouterContext_1 = require("./RouterContext");
const useRouter = ({ match }) => {
    const actions = (0, RouterContext_1.useRouterContext)();
    const render = actions.match(match);
    if (!render) {
        return { content: null };
    }
    const resourceName = actions.getResourceName();
    const content = render({
        params: actions.getParams(),
        query: actions.getQuery(),
        name: actions.getName()
    });
    return {
        content: resourceName
            ? react_1.default.createElement(guard_1.GuardResourceContext.Provider, { value: { resourceName } }, content)
            : content
    };
};
exports.useRouter = useRouter;
const useRouterActions = () => {
    return (0, RouterContext_1.useRouterContext)();
};
exports.useRouterActions = useRouterActions;
//# sourceMappingURL=hooks.js.map